export function renderChips({ index, icon = '', label = '', theme = '', content = '', isSelected = false, isEditable = false }) {
  const iconAttribute = icon ? `icon="${icon}"` : '';
  const labelAttribute = label ? `label="${label}"` : '';
  const indexAttribute = typeof index === 'undefined' ? '' : `index="${index}"`;
  const ariaSelectedAttribute = isSelected ? 'aria-selected="true"' : 'aria-selected="false"';
  const editableAttributes = isEditable ? `${ariaSelectedAttribute}` : '';

  return `<ewc-chips on-click-cell="chips"
    ${iconAttribute}
    ${labelAttribute}
    ${indexAttribute}
    ${theme} 
    ${editableAttributes}
  >
    ${content}
  </ewc-chips>`;
}
